import constants from "./constants";

const pageDetails = {
    pixelList: {
      title: constants.PIXEL_KEYWORD,
      description: ''
    },
    pixel: {
      title: constants.PIXEL_PAGE,
      description: 'Track and manage your pixel tracking data',
      icon: 'pixel' 
    },
    databaseList: {
      title: constants.LEADSEARCH_KEYWORD,
      description: ''
    },
    pixelConversion: {
      title: constants.PIXEL_CONVERSION,
      description: ''
    }
}

export default pageDetails;